import gql from 'graphql-tag';

const getPaymentInvoiceQuery = gql`
  query GetPaymentInvoice($invoiceId: String!, $organisationId: String!, $isUrl: Boolean) {
    getPaymentInvoice(invoiceId: $invoiceId, organisationId: $organisationId, isUrl: $isUrl) {
      invoiceUrl
      invoiceId
    }
  }
`;

const getPaymentInvoice = (organisationId) => ({
  query: getPaymentInvoiceQuery,
  module: 'payments',
  ignoreCache: true,
  buildVariables: ({
    invoiceId,
    isUrl



  }) => ({
    invoiceId,
    isUrl,
    organisationId
  })
});

export default getPaymentInvoice;